<div class="full-content">
  <div class="feature-wrapper sign">
    <div class="page-title">{{'mkb.card3dsecure.page.title' | resolve}}</div>
    <mat-card class="sign-content">
      <mat-card-content>
        <div class="sign-wrapper">
          <img class="sign-page-icon" src="assets/icons/mobile_icon.svg" />
          <div class="sign-page-title">{{'mkb.card3dsecure.page.sign.title' | resolve}}</div>
          <div class="sign-page-message">{{'mkb.card3dsecure.page.sign.sub.title' | resolve : {phoneNumber : ownersPhone} }}</div>
          <form [formGroup]="signFormGroup" autocomplete="off">
            <mat-form-field class="w-200">
              <div class="filed-title">{{'mkb.card3dsecure.page.sign.secure.code.input.title' | resolve}}</div>
              <input
                #tokenInput
                matInput
                digitOnly
                [maxLength]="TOKEN_LENGTH"
                formControlName="token">
              <mat-error *ngIf="signFormGroup?.get('token').hasError('required')">
                {{'mkb.card3dsecure.common.required.error' | resolve }}
              </mat-error>
              <mat-error *ngIf="signFormGroup?.get('token').hasError('minlength')">
                {{'mkb.card3dsecure.common.minlength.error' | resolve : {minlength : TOKEN_LENGTH} }}
              </mat-error>
              <mat-error *ngIf="signFormGroup?.get('token').hasError('maxlength')">
                {{'mkb.card3dsecure.common.maxlength.error' | resolve : {maxlength : TOKEN_LENGTH} }}
              </mat-error>
              <mat-error *ngIf="signFormGroup?.get('token').hasError('backenderror')">
                {{'mkb.card3dsecure.page.sign.confirmation.code.error' | resolve}}
              </mat-error>
            </mat-form-field>
          </form>
          <button mat-flat-button color="primary" (click)="submit()">
            {{'mkb.card3dsecure.page.sign.confirm.button.title' | resolve}}
          </button>
          <div class="sign-page-newsms">{{'mkb.card3dsecure.page.sign.sms.not.received.title' | resolve}}</div>
          <a class="sign-page-link" (click)="sendNewToken()">
            {{'mkb.card3dsecure.page.sign.send.new.sms.button.title' | resolve}}
          </a>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="side-bar-wrapper">
    <side-bar></side-bar>
  </div>
</div>
